/** Announce the visible count while keeping loading placeholders distinct from settled sections. */
export function getSectionAccordionHeaderLabel({
  count,
  isPlaceholder,
  title,
}: {
  count?: number;
  isPlaceholder?: boolean;
  title: string;
}): string {
  if (isPlaceholder === true) {
    return `Loading ${title}`;
  }
  return `${title}${count === undefined ? "" : ` (${count})`} section`;
}
